import { render, staticRenderFns } from "./ModalContentPost.vue?vue&type=template&id=20fc343e&"
import script from "./ModalContentPost.vue?vue&type=script&lang=js&"
export * from "./ModalContentPost.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports